export default {
    en: {
        catalog: "Catalog",
        addAuto: "+ Add Auto",
        logout: "Sign Out",
        about: "About App",
    },
    uk: {
        catalog: "Каталог",
        addAuto: "+ Добавить авто",
        logout: "Выйти",
        about: "О приложении",
    },
}